import _taggedTemplateLiteral from "/codebuild/output/src196865849/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  background: none;\n  color: ", ";\n  border: none;\n  padding: 0;\n  outline: inherit;\n  position: absolute;\n  right: 0;\n  top: 16px;\n  cursor: pointer;\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { typography, colors } from "../../../shared/constants";
export var Form = styled.form(_templateObject());
export var SubmitButton = styled.button(_templateObject2(), typography.buttonText, colors.green5, colors.teal5);